import { MockDb } from '../../../../mockDb';

const db = new MockDb('payment-mode', [
  { id: 1, name: "Cash", bankName: "Cash A/c", code: "PM-001", status: "Active", createdDate: "May 10, 2026" },
  { id: 2, name: "Cheque", bankName: "", code: "PM-002", status: "Active", createdDate: "May 12, 2026" },
  { id: 3, name: "DD/PO", bankName: "", code: "PM-003", status: "Active", createdDate: "May 14, 2026" },
  { id: 4, name: "Net Banking", bankName: "", code: "PM-004", status: "Active", createdDate: "May 16, 2026" },
  { id: 5, name: "Credit/Debit card", bankName: "", code: "PM-005", status: "Active", createdDate: "May 18, 2026" },
  { id: 6, name: "Finance", bankName: "", code: "PM-006", status: "Active", createdDate: "May 20, 2026" },
  { id: 7, name: "Wallet", bankName: "", code: "PM-007", status: "Active", createdDate: "May 22, 2026" },
  { id: 8, name: "Gift Voucher", bankName: "", code: "PM-008", status: "Active", createdDate: "May 24, 2026" },
  { id: 9, name: "G-pay", bankName: "", code: "PM-009", status: "Active", createdDate: "May 26, 2026" },
  { id: 10, name: "UPI Payment", bankName: "", code: "PM-010", status: "Active", createdDate: "May 28, 2026" },
  { id: 11, name: "Payment Gateway", bankName: "", code: "PM-011", status: "Active", createdDate: "May 30, 2026" },
  { id: 12, name: "AMAZON PAY", bankName: "ICICI BANK", code: "PM-012", status: "Active", createdDate: "Jun 01, 2026" },
]);

export async function listPaymentModes(params = {}) {
  await new Promise(r => setTimeout(r, 100));
  let list = db.getAll();
  
  if (params.viewMode === 'active') {
    list = list.filter(item => item.status === 'Active');
  } else if (params.viewMode === 'archived') {
    list = list.filter(item => item.status !== 'Active');
  }

  if (params.searchText) {
    const q = params.searchText.toLowerCase().trim();
    list = list.filter(item => 
      (item.name && item.name.toLowerCase().includes(q)) || 
      (item.bankName && item.bankName.toLowerCase().includes(q)) ||
      (item.code && item.code.toLowerCase().includes(q))
    );
  }

  return list;
}

export async function getPaymentModeDetail(paymentModeId) {
  await new Promise(r => setTimeout(r, 100));
  return db.get(paymentModeId);
}

export async function createPaymentMode(payload) {
  await new Promise(r => setTimeout(r, 100));
  return db.create(payload);
}

export async function updatePaymentMode(paymentModeId, payload) {
  await new Promise(r => setTimeout(r, 100));
  return db.update(paymentModeId, payload);
}

export async function archivePaymentMode(paymentModeId) {
  await new Promise(r => setTimeout(r, 100));
  return db.archive(paymentModeId);
}

export async function deletePaymentMode(paymentModeId) {
  await new Promise(r => setTimeout(r, 100));
  return db.delete(paymentModeId);
}
